<div *ngIf="!isLoading">
  <p-card *ngIf="isReady" [style]="{ width: '30%' }" class="flex align-items-center justify-content-center">
    <ng-template pTemplate="header">
      <span class="pi pi-check flex align-items-center justify-content-center mt-3" style="color: green; font-size: 4.5em;"></span>
    </ng-template>
    <ng-template pTemplate="title" class="flex align-items-center justify-content-center">
      <p class="flex align-items-center justify-content-center">review console</p>
    </ng-template>
    <ng-template pTemplate="subtitle" class="flex align-items-center justify-content-center">
      <p class="flex align-items-center justify-content-center">Run CAKE finished successfully</p>
    </ng-template>
  </p-card>
</div>

<app-loading class="mt-2 flex align-items-center justify-content-center" *ngIf="isLoading"></app-loading>